import type React from "react";
import { memo } from "react";
import type { Comment, CommenterDefinition } from "../../types/core";
import { CommentDisplay } from "./CommentDisplay";

interface CommentsPanelProps {
	comments: Comment[];
	commenterDefinitions: CommenterDefinition[];
	isLoading: boolean;
	isGenerationEnabled: boolean;
	onCommentClick: (commentId: string) => void;
	onGenerateClick: () => void;
}

/**
 * CommentsPanel component, memoized to prevent re-renders when other
 * unrelated state in the App (like live transcription segments) changes.
 */
export const CommentsPanel: React.FC<CommentsPanelProps> = memo(
	({
		comments,
		commenterDefinitions,
		isLoading,
		isGenerationEnabled,
		onCommentClick,
		onGenerateClick,
	}) => {
		return (
			<>
				<div className="p-4 border-b border-border-main bg-white/5 shrink-0">
					<div className="font-bold text-text-main flex items-center gap-2">
						<span role="img" aria-hidden="true">
							💬
						</span>{" "}
						コメント（タップでピックアップ）
					</div>
				</div>
				<CommentDisplay
					comments={comments}
					commenterDefinitions={commenterDefinitions}
					isLoading={isLoading}
					isGenerationEnabled={isGenerationEnabled}
					onCommentClick={onCommentClick}
					onGenerateClick={onGenerateClick}
					showTimestamps={false}
				/>
			</>
		);
	},
);
